<template>
    <v-card flat>
        <v-card-title class="text-h5 justify-space-around pt-2 pb-0" :class="[{ 'mb-12': !alarm.isactive }]">
            <p>UTC : <strong>{{ imageDescription.Denomination }}</strong> ({{ imageDescription.SerialNb }})</p>
            <p>Date : <strong>{{ imageDescription.Date }}</strong></p>
            <p>{{ $vuetify.lang.t('$vuetify.alarm.alarmDetailsCard.time') }} : <strong>{{ imageDescription.Time }}</strong></p>
        </v-card-title>
        <v-row v-if="alarm.isactive" justify="center" align="center" class="blink mb-2" dense>
            <v-col cols="auto">
                <v-icon color="red">mdi-alarm-light</v-icon>
            </v-col>
            <v-col cols="auto">
                <v-card-title class="red--text py-0">
                    {{ $vuetify.lang.t('$vuetify.alarm.alarmDetailsCard.thisalarmisactive') }}
                </v-card-title>
            </v-col>
        </v-row>
        <v-carousel
            delimiter-icon="mdi-minus-thick"
            :show-arrows="images.length > 1"
            height="650"
            @change="readMetadata"
            hide-delimiters 
            v-model="currentIndex"
        >
            <v-carousel-item
                v-for="(image, index) in images"
                :key="image.name"
            >
                <v-container class="pt-10">
                    <v-row justify="space-between">
                        <v-col cols="auto">
                            <v-skeleton-loader v-if="image.loading" type="image"></v-skeleton-loader>
                            <v-hover v-else>
                                <template v-slot:default="{ hover }">
                                    <div class="imageContainer ml-11">
                                        <canvas
                                            :id="'output'+index"
                                            :width="webImageWidth"
                                            :height="webImageHeight"
                                            style="border: solid black 1px"
                                            :style="hover ? 'cursor: crosshair' : ''"
                                            @click="(event) => readTemperature(event, index)"
                                        ></canvas>
                                        <p class="filename">{{ images[currentIndex].name }}</p>
                                        <p class="temperatureMaxAlarm">{{ imageDescription.TemperatureMax }} °C</p>
                                        <p class="temperatureMinAlarm">{{ imageDescription.TemperatureMin }} °C</p>
                                        <p :id="'currentTemperatureAlarm'+index" class="currentTemperatureAlarm">{{ cursorTemperature }} °C</p>
                                    </div>
                                </template>
                            </v-hover>
                            <img :id="'input'+index" style="display: none" :width="utcImageWidth" :height="utcImageHeight" :src="imageSrc" @load.once="loadOutput(index)">
                        </v-col>
                        <v-col cols="5" class="pt-0">
                            <v-tabs v-model="tab" fixed-tabs class="mt-n10 mb-2">
                                <v-tab>General</v-tab>
                                <v-tab>ROI / POI</v-tab>
                            </v-tabs>
                            <v-tabs-items v-model="tab">
                                <v-tab-item>
                                    <v-card flat :height="webImageHeight">
                                        <div class="text-subtitle-1 font-weight-bold mt-5">{{ $vuetify.lang.t('$vuetify.alarm.alarmDetailsCard.environment') }}</div>
                                        <v-row dense align="center">
                                            <v-col cols="auto">
                                                <v-icon color="black">mdi-thermometer</v-icon>
                                            </v-col>
                                            <v-col cols="auto">
                                                {{ $vuetify.lang.t('$vuetify.alarm.alarmDetailsCard.temperature') }} :
                                            </v-col>
                                            <v-col cols="auto">
                                                <strong>{{ imageDescription.TemperatureEnv ? Math.round((imageDescription.TemperatureEnv -5) * 100) / 100 : $vuetify.lang.t('$vuetify.alarm.alarmDetailsCard.notavailable') }}</strong>
                                                <template v-if="imageDescription.TemperatureEnv"> °C</template>
                                            </v-col>
                                        </v-row>
                                        <v-row dense align="center">
                                            <v-col cols="auto">
                                                <v-icon color="black">mdi-water-percent</v-icon>
                                            </v-col>
                                            <v-col cols="auto">
                                                {{ $vuetify.lang.t('$vuetify.alarm.alarmDetailsCard.humidity') }} :
                                            </v-col>
                                            <v-col cols="auto">
                                                <strong>{{ imageDescription.HumidityEnv ? Math.round(imageDescription.HumidityEnv * 100) / 100 : $vuetify.lang.t('$vuetify.alarm.alarmDetailsCard.notavailable') }}</strong>
                                                <template v-if="imageDescription.HumidityEnv"> %RH</template>
                                            </v-col>
                                        </v-row>
                                        <br />
                                        <div class="text-subtitle-1 font-weight-bold">{{ $vuetify.lang.t('$vuetify.alarm.alarmDetailsCard.configuration') }}</div>
                                        <v-row dense align="center">
                                            <v-col cols="auto">
                                                <v-icon color="black">mdi-speedometer</v-icon>
                                            </v-col>
                                            <v-col cols="auto">
                                                {{ $vuetify.lang.t('$vuetify.alarm.alarmDetailsCard.triggerthreshold') }} :
                                            </v-col>
                                            <v-col cols="auto">
                                                <strong>{{ securityClassification.Threshold ? securityClassification.Threshold : $vuetify.lang.t('$vuetify.alarm.alarmDetailsCard.notavailable') }}</strong>
                                                <template v-if="securityClassification.Threshold"> °C</template>
                                            </v-col>
                                        </v-row>
                                        <v-row dense align="center">
                                            <v-col cols="auto">
                                                <v-icon color="black">mdi-eye-arrow-left-outline</v-icon>
                                            </v-col>
                                            <v-col cols="auto">
                                                {{ $vuetify.lang.t('$vuetify.alarm.alarmDetailsCard.emissivity') }} :
                                            </v-col>
                                            <v-col cols="auto">
                                                <strong>{{ imageDescription.emissivity ? imageDescription.emissivity : $vuetify.lang.t('$vuetify.alarm.alarmDetailsCard.notavailable') }}</strong>
                                            </v-col>
                                        </v-row>
                                        <br />
                                        <div class="text-subtitle-1 font-weight-bold">{{ $vuetify.lang.t('$vuetify.alarm.alarmDetailsCard.internal') }}</div>
                                        <v-row dense align="center">
                                            <v-col cols="auto" class="pr-0">
                                                <v-icon color="black">mdi-thermometer</v-icon>
                                            </v-col>
                                            <v-col cols="auto" class="pl-0">
                                                <v-icon color="black">mdi-memory</v-icon>
                                            </v-col>
                                            <v-col cols="auto">
                                                {{ $vuetify.lang.t('$vuetify.alarm.alarmDetailsCard.fpatemperature') }} :
                                            </v-col>
                                            <v-col cols="auto">
                                                <strong>{{ imageDescription.TemperatureFPA ? imageDescription.TemperatureFPA : $vuetify.lang.t('$vuetify.alarm.alarmDetailsCard.notavailable') }}</strong>
                                                <template v-if="imageDescription.TemperatureFPA"> °C</template>
                                            </v-col>
                                        </v-row>
                                        <br />
                                        <div class="text-subtitle-1 font-weight-bold">{{ $vuetify.lang.t('$vuetify.alarm.alarmDetailsCard.measuredtemperatures') }}</div>
                                        <v-simple-table dense>
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th class="text-center">
                                                            {{ $vuetify.lang.t('$vuetify.alarm.alarmDetailsCard.measurements') }}
                                                        </th>
                                                        <th class="text-center">
                                                            Max
                                                        </th>
                                                        <th class="text-center">
                                                            Min
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <template v-for="measure in measurements">
                                                        <tr :key="measure.name" class="text-center">
                                                            <td>
                                                                <strong>{{ $vuetify.lang.t(measure.name) }}</strong>
                                                            </td>
                                                            <td>
                                                                <strong>{{ measure.max ? measure.max : $vuetify.lang.t('$vuetify.alarm.alarmDetailsCard.notavailable') }}</strong>
                                                                <template v-if="measure.max"> °C</template>
                                                            </td>
                                                            <td>
                                                                <strong>{{ measure.min ? measure.min : $vuetify.lang.t('$vuetify.alarm.alarmDetailsCard.notavailable') }}</strong>
                                                                <template v-if="measure.min"> °C</template>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-card>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-row>
                                        <v-col cols="6">
                                            <div class="text-subtitle-1 text-center font-weight-bold mb-2">{{ $vuetify.lang.t('$vuetify.alarm.alarmDetailsCard.regionsdata') }}</div>
                                            <v-simple-table dense v-if="imageDescription.regionDataTemp && imageDescription.regionDataTemp.length > 0">
                                                <template v-slot:default>
                                                    <thead>
                                                        <tr>
                                                            <th class="text-center">
                                                                {{ $vuetify.lang.t('$vuetify.alarm.alarmDetailsCard.region') }}
                                                            </th>
                                                            <th class="text-center">
                                                                Max
                                                            </th>
                                                            <th class="text-center">
                                                                Min
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <template v-for="region in imageDescription.regionDataTemp">
                                                            <tr :key="region.name" class="text-center">
                                                                <td>
                                                                    <strong>{{ region.name }}</strong>
                                                                </td>
                                                                <td>
                                                                    <strong>{{ region.max }}</strong> °C
                                                                </td>
                                                                <td>
                                                                    <strong>{{ region.min }}</strong> °C
                                                                </td>
                                                            </tr>
                                                        </template>
                                                    </tbody>
                                                </template>
                                            </v-simple-table>
                                            <div v-else class="text-center mt-2">{{ $vuetify.lang.t('$vuetify.noDataText') }}</div>
                                            <div class="text-subtitle-1 text-center font-weight-bold mt-6 mb-2">{{ $vuetify.lang.t('$vuetify.alarm.alarmDetailsCard.pointsdata') }}</div>
                                            <v-simple-table dense v-if="imageDescription.pointDataTemp && imageDescription.pointDataTemp.length > 0" :height="webImageHeight/2" fixed-header>
                                                <template v-slot:default>
                                                    <thead>
                                                        <tr>
                                                            <th class="text-center">
                                                                Point
                                                            </th>
                                                            <th class="text-center">
                                                                {{ $vuetify.lang.t('$vuetify.alarm.alarmDetailsCard.value') }}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <template v-for="point in imageDescription.pointDataTemp">
                                                            <tr :key="point.name" class="text-center">
                                                                <td>
                                                                    <strong>{{ point.name }}</strong>
                                                                </td>
                                                                <td>
                                                                    <strong>{{ point.value }}</strong> °C
                                                                </td>
                                                            </tr>
                                                        </template>
                                                    </tbody>
                                                </template>
                                            </v-simple-table>
                                            <div v-else class="text-center mt-2">{{ $vuetify.lang.t('$vuetify.noDataText') }}</div>
                                        </v-col>
                                        <v-divider vertical inset class="my-4"></v-divider>
                                        <v-col cols="6">
                                            <div class="text-subtitle-1 text-center font-weight-bold mb-2">{{ $vuetify.lang.t('$vuetify.alarm.alarmDetailsCard.alertrules') }}</div>
                                            <v-card flat :height="webImageHeight - 16" class="overflow-y-auto">
                                                <template v-if="imageDescription.rulesData && imageDescription.rulesData.length > 0">
                                                    <v-row
                                                        no-gutters
                                                        justify="center"
                                                        align="center"
                                                        v-for="rule in imageDescription.rulesData"
                                                        :key="'1' + rule.type + rule.elements + rule.value + rule.state"
                                                        class="mb-2"
                                                    >
                                                        <v-col cols="2">
                                                            <v-icon
                                                                :disabled="rule.state === '0'"
                                                                :color="rule.state === '2' ? 'red' : (rule.state === '1' ? 'green' : '') "
                                                            >
                                                                mdi-alert-circle-outline
                                                            </v-icon>
                                                        </v-col>
                                                        <v-col cols="10" class="text-justify">
                                                            <span v-if="['1', '2'].includes(rule.type)" style="vertical-align: middle !important">
                                                                {{ rule.elements.join("") }} > {{ rule.value }} °C
                                                            </span>
                                                            <span v-else-if="['3', '4'].includes(rule.type)" style="vertical-align: middle !important">
                                                                {{ $vuetify.lang.t('$vuetify.alarm.alarmDetailsCard.difference') }} > {{ rule.value }} °C {{ $vuetify.lang.t('$vuetify.alarm.alarmDetailsCard.in') }}
                                                                <br />
                                                                [ <span class="text-body-2">{{ rule.elements.join(", ") }}</span> ]
                                                            </span>
                                                        </v-col>
                                                    </v-row>
                                                </template>
                                                <div v-else class="text-center">{{ $vuetify.lang.t('$vuetify.noDataText') }}</div>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-tab-item>
                            </v-tabs-items>
                        </v-col>
                    </v-row>
                    <v-row v-if="securityClassification.NbDetections > 0">
                        <v-col :cols="securityClassification.NbDetections > 2 ? Math.round(1.2*securityClassification.NbDetections) : securityClassification.NbDetections === 2 ? 3 : 2 ">
                            <v-simple-table dense>
                                <template v-slot:default>
                                    <tbody>
                                        <tr>
                                            <th class="text-center">Index</th>
                                            <td class="text-center" v-for="n in securityClassification.NbDetections" :key="n">{{ n }}</td>
                                        </tr>
                                        <tr>
                                            <th class="text-center">Max</th>
                                            <td class="text-center" v-for="n in securityClassification.NbDetections" :key="n">{{ securityClassification["Maximal"+n] }} °C</td>
                                        </tr>
                                        <tr>
                                            <th class="text-center">Min</th>
                                            <td class="text-center" v-for="n in securityClassification.NbDetections" :key="n">{{ securityClassification["Minimal"+n] }} °C</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-container>
            </v-carousel-item>
        </v-carousel>
        <v-card-actions>
            <v-alert width="600" class="gradient-wintech text-body-2 mb-0" dense outlined icon="$info">
                {{ clickOnImage ? $vuetify.lang.t('$vuetify.alarm.alarmDetailsCard.cursortemperature') + ' : ' + cursorTemperature + ' °C' : $vuetify.lang.t('$vuetify.alarm.alarmDetailsCard.cursortooltip') }}
            </v-alert>
            <v-spacer />
            <strong>Image {{ (currentIndex + 1) }} / {{ images.length }}</strong>
            <v-spacer />
            <v-btn :class="alarm.isconsulted ? '' : 'gradient-wintech'" :disabled="alarm.isconsulted" :loading="ackLoading" @click="acknowledge(alarm.id)">
                <v-icon left>mdi-eye</v-icon>
                {{this.$vuetify.lang.t('$vuetify.alarm.alarmDetailsCard.acknowledge')}}
            </v-btn>
            <v-btn class="gradient-wintech" @click="downloadAlarmFolder(alarm.folder)">
                <v-icon left>mdi-download</v-icon>
                {{this.$vuetify.lang.t('$vuetify.alarm.alarmDetailsCard.download')}}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import axios from 'axios';
import JSZip from 'jszip';
import exifr from 'exifr';
import { mapGetters } from 'vuex';
import cv from '../../plugins/opencv';

export default {
    name: "AlarmsDetailCard",
    props: {
        alarm: Object,
        images: Array,
    },
    data() {
        return {
            ackLoading: false,
            imageDescription: {
                DateTime: "1970-01-01 00:00:00",
                Date: undefined,
                Time: undefined,
                Denomination: "",
                SerialNb: "",
                TemperatureEnv: undefined,
                HumidityEnv: undefined,
                TemperatureFPA: undefined,
                TemperatureMax: undefined,
                TemperatureMin: undefined,
                TemperatureMaxTotal: undefined,
                TemperatureMinTotal: undefined,
                regionDataTemp: [],
                pointDataTemp: [],
                rulesData: [],
            },
            securityClassification: {
                AlarmFolder: "",
                Threshold: "70",
                NbDetections: 10,
                Maximal1: "-500",
                Minimal1: "-500",
                Maximal2: "-500",
                Minimal2: "-500",
                Maximal3: "-500",
                Minimal3: "-500",
                Maximal4: "-500",
                Minimal4: "-500",
                Maximal5: "-500",
                Minimal5: "-500",
                Maximal6: "-500",
                Minimal6: "-500",
                Maximal7: "-500",
                Minimal7: "-500",
                Maximal8: "-500",
                Minimal8: "-500",
                Maximal9: "-500",
                Minimal9: "-500",
                Maximal10: "-500",
                Minimal10: "-500",
            },
            cursorTemperatures: [],
            cursorPositions: [],
            indicatorHeights: [],
            currentIndex: this.images.length-1,
            clickOnImage: false,
            tab: 0,
            webImageWidth: 550,
            webImageHeight: 423,
            utcImageWidth: 170,
            utcImageHeight: 120,
            utcColormapWidth: 10
        }
    },
    mounted(){
        this.readMetadata()
    },
    computed: {
        ...mapGetters({ user: "StateUser" }),
        cursorTemperature() {
            return this.clickOnImage ? this.cursorTemperatures[this.currentIndex] : undefined;
        },
        isTiff() {
            return this.images[this.currentIndex].tiff !== undefined;
        },
        imageSrc() {
            return this.isTiff ? undefined : this.images[this.currentIndex].url;
        },
        showRoiAndPoi() {
            return this.tab === 1
        },
        utcImageWidthWithoutColormap() {
            return this.utcImageWidth - this.utcColormapWidth
        },
        measurements() {
            return [
                {
                    name: "$vuetify.alarm.alarmDetailsCard.masksexcluded",
                    max: this.imageDescription.TemperatureMax,
                    min: this.imageDescription.TemperatureMin
                },
                {
                    name: "$vuetify.alarm.alarmDetailsCard.masksincluded",
                    max: this.imageDescription.TemperatureMaxTotal,
                    min: this.imageDescription.TemperatureMinTotal
                }
            ]
        },
    },
    watch: {
        showRoiAndPoi() {
            this.loadOutput(this.currentIndex);
        }
    },
    methods: {
        async acknowledge(alarmId) {
            this.ackLoading = true;
            const res = await axios.put('alarms/'+alarmId);
            if (res.status == 200) {
                this.alarm.isconsulted = true;
            }
            this.ackLoading = false;            
        },

        async downloadAlarmFolder(folder) {
            var zip = new JSZip();
            for (const i in this.images) {
                zip.file(this.images[i].name, this.images[i].blob);
            }
            const content = await zip.generateAsync({type: "blob"});
            const link = document.createElement('a');
            link.href = URL.createObjectURL(content);
            link.download = folder + '.zip';
            document.body.appendChild(link);
            link.dispatchEvent(
                new MouseEvent('click', { 
                    bubbles: true, 
                    cancelable: true, 
                    view: window 
                })
            );
            document.body.removeChild(link);
        },

        async readMetadata() {
            this.clickOnImage = false;
            if (this.cursorTemperatures[this.currentIndex] !== undefined) {
                this.clickOnImage = true;
            }
            try {
                let output = await exifr.parse(this.images[this.currentIndex].blob, true);
                let imageDescription = JSON.parse(output['ImageDescription'].replace(/'/g, "\""));
                let datetime = new Date(imageDescription.DateTime);
                imageDescription.Date = datetime.getDate().toString().padStart(2, '0') + "/" + (1 + datetime.getMonth()).toString().padStart(2, '0') + "/" + datetime.getFullYear();
                imageDescription.Time = datetime.getHours().toString().padStart(2, '0') + ":" + datetime.getMinutes().toString().padStart(2, '0') + ":" + datetime.getSeconds().toString().padStart(2, '0');
                this.imageDescription = imageDescription;
                let securityClassification = {};
                if (output[37394]) {
                    securityClassification = JSON.parse(output[37394].replace(/'/g, "\""))
                    securityClassification['NbDetections'] = parseInt(securityClassification['NbDetections'], 10);
                } else {
                    securityClassification = {
                        Threshold: imageDescription.threshold,
                        NbDetections: parseInt(imageDescription.NbDetections, 10),
                    };
                    for (let n = 1; n <= securityClassification.NbDetections; n++) {
                        securityClassification["Maximal"+n] = imageDescription["Maximal"+n];
                        securityClassification["Minimal"+n] = imageDescription["Minimal"+n];
                    }
                }
                this.securityClassification = securityClassification;
            } catch(err) {
                if (err instanceof TypeError) {
                    return;
                } else {
                    console.error(err);
                }
            }
            if (this.isTiff) this.loadOutput(this.currentIndex);
        },

        loadOutput(index) {
            var src;
            if (this.isTiff) {
                if (this.showRoiAndPoi) {
                    src = cv.matFromArray(this.utcImageHeight, this.utcImageWidth, cv.CV_8UC3, this.images[index].tiff[2].data);
                } else {
                    src = cv.matFromArray(this.utcImageHeight, this.utcImageWidth, cv.CV_8UC3, this.images[index].tiff[0].data);
                }
            } else {
                let input = document.getElementById('input'+index);
                src = cv.imread(input);
            }
            let dst = new cv.Mat();
            let dsize = new cv.Size(this.webImageWidth, this.webImageHeight);
            cv.resize(src, dst, dsize, 0, 0, cv.INTER_AREA);

            if (this.clickOnImage) this.drawTemperatureCursorAndIndicatorOnMat(dst);
            
            let output = document.getElementById('output'+index);
            cv.imshow(output, dst);
            src.delete(); dst.delete();
        },

        readTemperature(event, index) {
            this.currentIndex = index;
            var src, data;
            if (this.isTiff) {
                if (this.showRoiAndPoi) {
                    src = cv.matFromArray(this.utcImageHeight, this.utcImageWidth, cv.CV_8UC3, this.images[index].tiff[2].data);
                } else {
                    src = cv.matFromArray(this.utcImageHeight, this.utcImageWidth, cv.CV_8UC3, this.images[index].tiff[0].data);
                }
                data = cv.matFromArray(this.utcImageHeight, this.utcImageWidthWithoutColormap, cv.CV_16UC1, this.images[index].tiff[1].data);
            } else {
                let input = document.getElementById('input'+index);
                src = cv.imread(input);
            }
            let mat = new cv.Mat.zeros(src.rows, src.cols, cv.CV_8UC3);
            let dsize = new cv.Size(this.webImageWidth, this.webImageHeight);
            cv.resize(src, mat, dsize, 0, 0, cv.INTER_AREA);
            if (this.isTiff) {
                let dataSize = new cv.Size(this.utcImageWidthWithoutColormap*mat.cols/this.utcImageWidth, this.webImageHeight);
                cv.resize(data, data, dataSize, 0, 0, cv.INTER_AREA);
            }
            src.delete();
            let currentTemperature = document.getElementById('currentTemperatureAlarm'+index);
            if (mat.isContinuous() && event.offsetX < Math.floor(this.utcImageWidthWithoutColormap*mat.cols/this.utcImageWidth) && event.offsetY < mat.rows) { // check if cursor is in image
                this.clickOnImage = false; // reset value to false for cursorTemperature computed value to identify the changes
                this.clickOnImage = true; 
                this.cursorPositions[index] = {
                    x: event.offsetX,
                    y: event.offsetY
                }
                if (this.isTiff) {
                    let pixelValue = data.ushortPtr(this.cursorPositions[index].y, this.cursorPositions[index].x);
                    this.cursorTemperatures[index] = Math.pow(-1, (pixelValue & 0x8000) >> 15)*(pixelValue & 0x7FFF) / 10.0;
                    this.indicatorHeights[index] = mat.rows *(1 - Math.max(0, Math.min(1, ((this.cursorTemperatures[index] - parseFloat(this.imageDescription.TemperatureMin)) / (parseFloat(this.imageDescription.TemperatureMax) - parseFloat(this.imageDescription.TemperatureMin))))));
                    data.delete();
                } else {
                    let pixel = mat.ucharPtr(event.offsetY, event.offsetX);
                    
                    let green = pixel[1]; // offset is pixel green level
                    let grayLevel;
                    if (green < 28) {
                        grayLevel = pixel[0]; // before 28, consider same behavior between red level and gray level (6 dl of difference at most)
                    } else if (green > 250) {
                        grayLevel = green // after 250, consider same behavior between green level and gray level (1 dl of difference at most)
                    } else { 
                        let a = 0.0049, b = -0.238, c = 10.962; // quadratic equation of green level / gray level
                        let discriminant = b*b - 4*a*(c-green);
                        let root1, root2;
                        if (discriminant > 0) {
                            root1 = (-b + Math.sqrt(discriminant)) / (2 * a);
                            root2 = (-b - Math.sqrt(discriminant)) / (2 * a);
                        } else if (discriminant == 0) {
                            root1 = root2 = -b / (2*a);
                        } else {
                            root1 = root2 = 0; // temperature = min if discriminant is negative i.e. roots = 0
                        }
                        grayLevel = Math.round(Math.max(root1, root2)); // gray level is positive
                    }

                    let coeff = grayLevel/255;
                    let temperature = coeff * (parseFloat(this.imageDescription.TemperatureMax) - parseFloat(this.imageDescription.TemperatureMin)) + parseFloat(this.imageDescription.TemperatureMin);
                    this.cursorTemperatures[index] = temperature.toFixed(1);
                    this.indicatorHeights[index] = (1-coeff)*mat.rows;
                }

                this.drawTemperatureCursorAndIndicatorOnMat(mat);
            } else {
                this.cursorTemperatures[index] = undefined;
                currentTemperature.style.display = 'none';
                this.clickOnImage = false;
            }
            let output = event.srcElement; // output canvas
            cv.imshow(output, mat)
            mat.delete();
        },

        drawTemperatureCursorAndIndicatorOnMat(mat) {
            // draw cross at cursor position
            let start1 = new cv.Point(this.cursorPositions[this.currentIndex].x - 12, this.cursorPositions[this.currentIndex].y);
            let end1 = new cv.Point(this.cursorPositions[this.currentIndex].x + 12, this.cursorPositions[this.currentIndex].y);
            let start2 = new cv.Point(this.cursorPositions[this.currentIndex].x, this.cursorPositions[this.currentIndex].y - 12);
            let end2 = new cv.Point(this.cursorPositions[this.currentIndex].x, this.cursorPositions[this.currentIndex].y + 12);
            let lineColor = new cv.Scalar(255, 0, 0, 255);
            cv.line(mat, start1, end1, lineColor, 2, cv.LINE_AA, 0);
            cv.line(mat, start2, end2, lineColor, 2, cv.LINE_AA, 0);

            let currentTemperature = document.getElementById('currentTemperatureAlarm' + this.currentIndex);
            if (!currentTemperature.classList.contains('d-none')) {
                // draw line on colormap corresponding to selected color
                let p1 = new cv.Point(mat.cols - 28, this.indicatorHeights[this.currentIndex]);
                let p2 = new cv.Point(mat.cols, this.indicatorHeights[this.currentIndex])
                cv.line(mat, p1, p2, lineColor, 2, cv.LINE_AA, 0);

                // write new temp above indicator
                let textHeight = this.indicatorHeights[this.currentIndex] - 10;
                currentTemperature.style.top = textHeight + 'px';
                currentTemperature.style.display = 'block';
            }
        },
    }
}
</script>

<style lang="scss" scoped>

    .blink {
        animation: blink-animation 1s steps(3, start) infinite;
        -webkit-animation: blink-animation 1s steps(3, start) infinite;
    }
    @keyframes blink-animation {
        to {
            visibility: hidden;
        }
    }
    @-webkit-keyframes blink-animation {
        to {
            visibility: hidden;
        }
    }

    .imageContainer {
        position: relative;
        text-align: center;
        color: black;
    }

    .filename {
        position: absolute;
        bottom: -36px;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .temperatureMaxAlarm {
        position: absolute;
        top: -24px;
        right: 0;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .temperatureMinAlarm {
        position: absolute;
        bottom: -36px;
        right: 0;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .currentTemperatureAlarm {
        display: none;
        position: absolute;
        right: -62px;
        color: red;
        font-weight: 500;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
        padding: 0 !important;
    }
</style>
